// extracted by mini-css-extract-plugin
export default {"options":"event-permissions_options__RpkI8","contributorsList":"event-permissions_contributorsList__LZsyI"};